<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">{{ $store.state.themeTitle }}室经费数据情况</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <!-- <el-form-item label="计划状态">
          <el-select v-model="formInline.status" clearable placeholder="请选择计划状态">
            <el-option v-for="item in $store.state.planStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="formInline.apply_status" clearable placeholder="请选择审核状态">
            <el-option v-for="item in $store.state.applyStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-input v-model="formInline.training_name" clearable :placeholder="`请输入${$store.state.themeTitle}室名称`"></el-input>
        </el-form-item> -->
        <el-form-item label="院系">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <!-- <el-input v-model="formInline.structure_1" placeholder="请输入所属院系"></el-input> -->
          <el-input v-model="formInline.structure_1" placeholder="请选择院系" @focus="dialogOpen1" @clear="handeleClear1"
            clearable></el-input>

        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_name" clearable filterable
            :placeholder="`请选择${$store.state.themeTitle}室`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile" @refresh="handleQuery" :action="action" :params="params"
            btnTitle="导入数据"></Importt>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-descriptions title="经费投入汇总" direction="vertical" :column="sum.length" border>
        <el-descriptions-item v-for="item in sum" :key="item.type" :label="item.type">{{ item.amount
          }}元</el-descriptions-item>
      </el-descriptions>
    </div>
    <div>
      <h4 style="padding:30px 0 20px;color:#111;">经费情况明细</h4>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column prop="item_name" label="申报项目明细" min-width="220">
        </custom-table-column>
        <custom-table-column prop="type" label="经费类型" width="180">
        </custom-table-column>
        <custom-table-column prop="declarant" label="申报人" width="120">
        </custom-table-column>
        <custom-table-column prop="date" label="申报日期" width="160">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="training_no" :label="`${$store.state.themeTitle}室编号`" width="140">
        </custom-table-column>
        <custom-table-column prop="training_name" :label="`${$store.state.themeTitle}室`" width="160">
        </custom-table-column>
        <custom-table-column prop="term" label="学期" width="160">
        </custom-table-column>
        <custom-table-column prop="is_reimburse" label="财务报账" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_reimburse == 0">否</span>
            <span v-if="scope.row.is_reimburse == 1">是</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="amount" label="实际金额（元）" width="120">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="180">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="120">
        </custom-table-column>
        <custom-table-column label="凭证附件" min-width="160">
          <template slot-scope="scope" v-if="scope.row.attachment">
            <el-link type="primary" v-for="(item, index) in scope.row.attachment.split(',')" :href="item"
              :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="upFile(scope.row.id)" type="text" size="small">上传凭证</el-button>
            <el-button @click="handleEdit(scope.row, ['display_order', 'school_id'])" type="text"
              size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery">
      </OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="院  系" prop="structure_1">
          <el-input v-model="ruleForm.structure_1" placeholder="请选择所属院系" style="width:216px;" @focus="dialogOpen"
            @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_room_id">
          <el-select v-model="ruleForm.training_room_id" filterable style="width:216px;"
            :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学  期" prop="term">
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报项目明细" prop="item_name">
          <el-input v-model="ruleForm.item_name" placeholder="请输入申报项目明细" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="经费类型" prop="type">
          <el-select v-model="ruleForm.type" style="width:216px;" placeholder="请选择经费类型">
            <el-option v-for="item in $store.state.funds" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否财务报账" prop="is_reimburse">
          <el-select v-model="ruleForm.is_reimburse" style="width:216px;" placeholder="请选择是否财务报账 ">
            <el-option v-for="item in $store.state.iss" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实际金额" prop="amount">
          <el-input v-model="ruleForm.amount" placeholder="请输入实际金额" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="申报人" prop="declarant">
          <el-input v-model="ruleForm.declarant" placeholder="请输入申报人" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="申报日期" prop="date">
          <el-date-picker v-model="ruleForm.date" value-format="yyyy-MM-dd" type="date" placeholder="请选择申报日期"
            style="width:216px;"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="开始时间" prop="start_time">
          <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间" v-model="ruleForm.start_time" style="width:216px;"></el-date-picker>
        </el-form-item> -->
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="上传凭证" :visible.sync="fileUpDialogVisible" width="546px">
      <el-form :model="ruleFormFile" :rules="rulesFile" ref="ruleFormFile" label-width="120px" class="demo-ruleForm">
        <el-form-item label="凭证附件" prop="attachment" style="width:100%">
          <Uploadd ref="uploadd" fileFormNameIn="ruleFormFile" fileFieldNameIn="attachment" :isMultiple="true"
            btnTitle="点击上传文件" @setFileList="setFileListMultiple" @delFile="delUpFile"></Uploadd>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleFormFile', upFileMethod)">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate, mixinUpload],
  data() {

    return {
      classRooms: [],
      institutes: [],
      formInline: {
        structure_1: '',
        training_name: '',
      },
      levell: [1],
      users: [],
      loading: false,
      ruleForm: {
        structure_1: '',
        term: '',
        item_name: '',
        type: '',
        is_reimburse: '',
        amount: '',
        declarant: '',
        date: '',
      },
      rules: {
        training_room_id: [{ required: true, message: '请选择', trigger: 'change' }],
        structure_1: [{ required: true, message: '请选择院系', trigger: 'change' }],
        term: [{ required: true, message: '请选择', trigger: 'change' }],
        item_name: [{ required: true, message: '请输入申报项目明细', trigger: 'blur' }],
        type: [{ required: true, message: '请选择经费类型', trigger: 'change' }],
        is_reimburse: [{ required: true, message: '请选择是否财务报账', trigger: 'change' }],
        amount: [
          { required: true, message: '实际金额不能为空' },
          { validator: this.checkfloat, trigger: 'blur' }
        ],
        declarant: [{ required: true, message: '请输入申报人', trigger: 'blur' }],
        date: [{ required: true, message: '请选择申报日期', trigger: 'change' }],
      },
      type: 'add',
      tableName: '实训日志',
      downloadUrl: 'template/经费数据导入模版.xlsx',
      sum: [],
      action: '',
      fileUpDialogVisible: false,
      ruleFormFile: {
        id: '',
        attachment: '',
      },
      rulesFile: {
        attachment: [{ required: true, message: '请上传凭证附件', trigger: 'change' }],
      },
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/xmhy/training_room/funds/import`;
    this.$store.dispatch('getFunds');
  },
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
    this.$store.dispatch('getTermms');
  },
  methods: {
    upFile(id) {
      this.ruleFormFile = {
        id,
        attachment: '',
      };
      if (this.$refs.uploadd) {
        this.$refs.uploadd.setRefFileList('');
      }
      this.fileUpDialogVisible = true;
    },
    async upFileMethod() {
      const params = {
        id: this.ruleFormFile.id,
        attachment: this.ruleFormFile.attachment,
      };
      const res = await this.$api.instance.interfaceServer(
        'api/xmhy/training_room/funds/attachment/add',
        'post',
        params
      );
      if (res.code == 0) {
        this.$message.success('上传成功');
        this.fileUpDialogVisible = false;
        this.handleQuery();
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleTeacherChange(val) {
      this.ruleForm.teacher = this.$until.getLabelName(this.users, 'number', 'name', val);
    },
    getOrganList() {
      if (this.selectNode.level == 1) {
        this.ruleForm.structure_1 = this.selectNode.structure_names;
      } else {
        this.ruleForm.structure_1 = '';
      }
    },
    async remoteMethod(query) {
      this.loading = true;
      this.users = [];
      let params = {
        page: 1,
        size: 10,
        name: query,
      };
      // console.log(query)
      // return
      let res = await this.$api.query.getUsersUnLoad(params);
      if (res.code == 0 && res.data) {
        this.users = res.data.data;
        // this.total = res.data.total;
      }
      this.loading = false;

      // this.users = res.data.data;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleApply(apply_id, apply_status) {
      let str = '通过';
      if (apply_status == 2) {
        str = '拒绝';
      }
      this.$confirm(`此操作将${str}该实训计划, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.applyStatus(apply_id, apply_status, str);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async applyStatus(plan_id, apply_status, str) {
      let params = { plan_id, apply_status };
      let res = await this.$api.update.applyPlanStatus(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `${str}成功!`,
        });
        this.handleQuery();
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
      this.ruleForm.training_no = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_no', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteTrainRommFunds(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.creatTrainRommFunds(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.update.updateTrainRommFunds(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields();
    // },
    handleQuery() {
      if (this.selectNodeForQuery.level == 1) {
        this.formInline.structure_1 = this.selectNodeForQuery.structure_names;
      } else {
        this.formInline.structure_1 = '';
      }
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getTrainFunds(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.sum = res.data.sum;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

/deep/.el-descriptions-item__label.is-bordered-label {
  color: #111;
  font-weight: bold;
}
</style>
